import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import useMultiLanguage from "../../hook/useMultiLanguage";
import { INIT_SEARCH_OBJECT, RESPONSE_STATUS_CODE, TYPE } from "../constants/moduleConsts";
import InputSearch from "../components/input/InputSearch";
import { GroupButton } from "../components/GroupButton";
import AppContext from "../../AppContext";
import TableCustom, { columnNamesType } from "../components/table-custom/TableCustom";
import { hasAuthority } from "../utils/functionUtils";
import { PERMISSION_ABILITY, PERMISSIONS } from "../../constants";
import ScheduleConfigForm from "./components/ScheduleConfigForm";
import { IScheduleConfig } from "./models/categoryModels";
import { toast } from "react-toastify";
import { deleteDayTruc, searchListDayTruc } from "../timesheet/services/timesheetServices";
import { LIST_TYPE_SCHEDULE } from "./constants/approvalConfigConsts";
import CustomTooltip from "../components/custom-tooltip";
import { KTSVG } from "../../../_metronic/helpers";

const ScheduleConfig = () => {
    const { lang } = useMultiLanguage();
    const { setPageLoading } = useContext(AppContext);

    const [listScheduleConfig, setLisScheduleConfig] = useState<IScheduleConfig[]>([]);
    const [searchObject, setSearchObject] = useState<any>(INIT_SEARCH_OBJECT);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [openScheduleConfigForm, setOpenScheduleConfigForm] = useState<boolean>(false);
    const [scheduleConfigInfo, setScheduleConfigInfo] = useState<any>({} as IScheduleConfig);
    const [isView, setIsView] = useState(false);

    useEffect(() => {
        if (searchObject?.pageIndex && searchObject?.pageSize) {
            handleSearch();
        }
    }, [searchObject?.pageIndex, searchObject?.pageSize])

    const getListScheduleConfig = async (searchData?: any) => {
        try {
            setPageLoading(true);
            setSearchObject({ ...searchData })
            const { data } = await searchListDayTruc(searchData);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                setLisScheduleConfig(data?.data?.content || []);
                setTotalPage(data?.data?.totalPages);
                setTotalElements(data?.data?.totalElements);
                setNumberOfElements(data?.data?.numberOfElements);
            } else {
                toast.warning(data?.message);
            }
        } catch (err) {
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    };

    const handleSearch = (data: any = {}) => {
        const dataSearch: any = {
            ...searchObject,
            ...data
        };
        dataSearch.keyword = dataSearch?.keyword?.trim() || "";
        getListScheduleConfig(dataSearch);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchObject({
            ...searchObject,
            keyword: e.target?.value
        });
    };

    const handleOpenCreateDialog = () => {
        setIsView(false);
        setOpenScheduleConfigForm(true);
    };

    const handleDeleteItem = async (ids: string[]) => {
        try {
          const { data } = await deleteDayTruc(ids)
          if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
            toast.success(lang("APPROVAL_CONFIG.DELETE"))
            await getListScheduleConfig(searchObject);
            return true;
          } else {
            toast.warning(data?.message)
          }
        }
        catch (err: any) {
          toast.error(lang("GENERAL.ERROR"));
        }
      }

    const handleOpenForm = (info: any) => {
        setIsView(true);
        setOpenScheduleConfigForm(true);
        setScheduleConfigInfo(info);
    };

    const handleClose = () => {
        setOpenScheduleConfigForm(false);
        setScheduleConfigInfo({} as any);
    };

    const handleCloseAndSearch = () => {
        handleSearch();
        handleClose();
    };

    const columns: columnNamesType[] = [
        {
            name: "STT",
            field: "",
            render: (_row: any, _index: number, stt: number) => <span>{stt}</span>
        },
        {
            name: lang("SCHEDULE_CONFIG.CODE"),
            field: "code",
            headerStyle: {
                minWidth: "100px"
            },
            cellStyle: {
                textAlign: "center"
            },
            render: row => <span>{row?.code}</span>
        },
        {
            name: lang("SCHEDULE_CONFIG.TYPE"),
            field: "type",
            headerStyle: {
                minWidth: "100px"
            },
            cellStyle: {
                textAlign: "center"
            },
            render: row => {
                const findType = LIST_TYPE_SCHEDULE(lang).find((type) => type.code === row?.type);
                return (
                    <span>{findType ? findType.name : ''}</span>
                )
            }
        },
        {
            name: lang("SCHEDULE_CONFIG.NAME"),
            field: "name",
            headerStyle: {
                minWidth: "200px"
            },
            cellStyle: {
                textAlign: "left"
            },
        }
    ];

    return (
        <div className="spaces px-8 py-12 flex-1">
            <Row className="spaces mb-12 flex-middle flex-space-between">
                <Col xs={5} xl={6} xxl={7} className="p-0">
                    <h2 className="breadcrumb-title">{lang("SCHEDULE_CONFIG.LIST")}</h2>
                </Col>
                <Col xs={5} xl={3} xxl={3} className="flex">
                    <div className="spaces mr-10 flex-1">
                        <InputSearch
                            className="border-3px"
                            value={searchObject?.keyword}
                            placeholder="Tìm kiếm"
                            handleSearch={() => handleSearch({ pageIndex: 1 })}
                            handleChange={handleChange}
                            isEnter
                        />
                    </div>
                    <GroupButton handleEvent={() => handleSearch({ pageIndex: 1 })}>
                        {lang("BTN.SEARCH")}
                    </GroupButton>
                </Col>
            </Row>
            <Row className="bg-white">
                <Col className="table-scroll">
                    <TableCustom
              id="approval-config-list"
              data={listScheduleConfig}
              columns={columns}
              searchObject={searchObject}
              setSearchObject={setSearchObject}
              buttonAdd={hasAuthority(PERMISSIONS["DANH_MUC.CHAM_CONG.CAU_HINH_DAY_TRUC"], PERMISSION_ABILITY.CREATE)}
              notDelete={!hasAuthority(PERMISSIONS["DANH_MUC.CHAM_CONG.CAU_HINH_DAY_TRUC"], PERMISSION_ABILITY.DELETE)}
              type={TYPE.MULTILINE}
              totalPages={totalPage}
              totalElements={totalElements}
              numberOfElements={numberOfElements}
              handleOpenDialog={handleOpenCreateDialog}
              handleDoubleClick={(row: any) => handleOpenForm(row)}
              handleDelete={(ids: string[]) => handleDeleteItem(ids)}
            />
                </Col>
            </Row>
            {openScheduleConfigForm && (
                <ScheduleConfigForm
                    open={openScheduleConfigForm}
                    handleClose={handleClose}
                    handleCloseAndSearch={handleCloseAndSearch}
                    scheduleConfigInfo={scheduleConfigInfo}
                    isView={isView}
                />
            )}
        </div>
    )
};

export { ScheduleConfig };